var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_495_3150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11C22 13.1756 21.3549 15.3023 20.1462 17.1113C18.9375 18.9202 17.2195 20.3301 15.2095 21.1627C13.1995 21.9952 10.9878 22.2131 8.85401 21.7886C6.72022 21.3642 4.76021 20.3166 3.22183 18.7782C1.68345 17.2398 0.635804 15.2798 0.211367 13.146C-0.213071 11.0122 0.00476617 8.80047 0.83733 6.79048C1.66989 4.7805 3.07979 3.06253 4.88873 1.85383C6.69767 0.645139 8.82441 0 11 0C13.9174 0 16.7153 1.15893 18.7782 3.22183C20.8411 5.28473 22 8.08262 22 11Z",
    fill: "#44D7B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2345 7.81601C15.3821 7.96377 15.4651 8.16412 15.4651 8.37301C15.4651 8.5819 15.3821 8.78225 15.2345 8.93001L9.98449 14.184C9.83672 14.3317 9.63638 14.4146 9.42749 14.4146C9.21859 14.4146 9.01825 14.3317 8.87049 14.184L6.77049 12.084C6.69721 12.0109 6.63906 11.924 6.59935 11.8284C6.55964 11.7328 6.53916 11.6303 6.53906 11.5267C6.53897 11.4232 6.55927 11.3206 6.59881 11.2249C6.63834 11.1293 6.69634 11.0423 6.76949 10.969C6.91721 10.821 7.11768 10.7378 7.32678 10.7376C7.43032 10.7375 7.53286 10.7578 7.62855 10.7973C7.72424 10.8369 7.81121 10.8949 7.88449 10.968L9.42849 12.512L11.7765 10.164L14.1245 7.81601C14.2721 7.66957 14.4716 7.5874 14.6795 7.5874C14.8874 7.5874 15.0869 7.66957 15.2345 7.81601Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_495_3150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluecheck);
export default __webpack_public_path__ + "static/media/bluecheck.43b8cb23ca9423054dd2ec81dc1c9c1e.svg";
export { ForwardRef as ReactComponent };